import { API } from '../utils/constants'

const apiPath = API + '/contracts'

export async function getAllContracts(params?: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer' + _token,
    },
  }
  let res: any = null

  await fetch(
    params
      ? `${apiPath}?start_date=${params.start ?? ''}&end_date=${params.end ?? ''}&status=${params.status ?? ''}`
      : apiPath,
    requestOptions,
  ).then((response) => {
    res = response.json()
  })

  return res
}

export async function getContract(id: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer' + _token,
    },
  }
  let res: any = null

  await fetch(`${apiPath}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function quotationHaveContract(id: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(`${apiPath}/check/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function deleteContract(id: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(`${apiPath}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function registerContract(body?: any, files?: any) {
  const _token = localStorage.getItem('__token')
  const form = new FormData()
  form.append('effective_at', body.effective_at)
  form.append('payment_deadline', body.payment_deadline)
  form.append('quotation', body.quotation ?? '')
  form.append('service', body.service ?? '')
  form.append('from_quotation', body.from_quotation)
  form.append('description', body.description ?? '')
  form.append('contact', body.contact ?? '')
  form.append('duration', body.duration)
  form.append('title', body.title)

  for (const e of files) form.append('files[]', e)

  const requestOptions = {
    method: 'POST',
    headers: {
      Authorization: 'Bearer' + _token,
    },
    body: form,
  }
  let res: any = null

  await fetch(apiPath, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}
